import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function ReserveIntro() {
  return <section id="reserve-intro" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-primary font-default leading-tight mb-4">ご予約・お問い合わせ</h1>
        <Separator className="w-12 h-0.5 bg-primary mb-8" />
        <div className="space-y-6">
          <p className="text-foreground leading-relaxed font-default">四谷三丁目駅から徒歩約4分、曙橋駅から徒歩約7分の心理カウンセリングルームです。対面・オンラインのどちらもお選びいただけます。</p>
          <p className="text-foreground leading-relaxed font-default">まだ相談内容がまとまっていない段階でも、「話を聞いてもらえるか確かめたい」というご連絡で構いません。</p>
        </div>
        <dl className="mt-10 border-y border-border divide-y divide-border">
          <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
            <dt className="font-bold text-foreground font-default">料金</dt>
            <dd className="text-foreground font-default leading-relaxed">お一人 8,000円／複数人（カップル・ファミリー）10,000円／オンライン 8,000円<span className="block text-sm text-muted-foreground mt-1">いずれも1回50分・税込</span></dd>
          </div>
          <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
            <dt className="font-bold text-foreground font-default">開室時間</dt>
            <dd className="text-foreground font-default">10:00〜21:00（不定休）</dd>
          </div>
          <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
            <dt className="font-bold text-foreground font-default">お返事</dt>
            <dd className="text-foreground font-default leading-relaxed">当日中、または翌日までにお返事いたします。</dd>
          </div>
          <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
            <dt className="font-bold text-foreground font-default">お電話</dt>
            <dd className="text-foreground font-default leading-relaxed">
              <a href="tel:080-9553-8244" className="text-primary-heading underline underline-offset-4">080-9553-8244</a>
              <span className="block text-sm text-muted-foreground mt-1">つながらない場合は、留守番電話にお名前とご連絡先を残してください。</span>
            </dd>
          </div>
          <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
            <dt className="font-bold text-foreground font-default">所在地</dt>
            <dd className="text-foreground font-default leading-relaxed">〒160-0006<br />東京都新宿区舟町4-1<br />メゾンド四谷303号室</dd>
          </div>
        </dl>
        <p className="mt-6 text-sm text-muted-foreground font-default leading-relaxed">初回面接の流れは<Link to="https://yotsuya-sc-room.com/flow/" className="text-primary-heading underline underline-offset-4">カウンセリングの流れ</Link>を、料金の詳細は<Link to="https://yotsuya-sc-room.com/menu/" className="text-primary-heading underline underline-offset-4">カウンセリングメニュー・料金</Link>をご覧ください。</p>
      </div>
    </section>;
}